import type { I18nFn } from '#/i18n/types/I18nFn';
import { EVENT_LOCATION_TYPE } from '#/utils/constants/general/eventLocationType';
import { LOCATION_TYPE } from '#/utils/constants/general/locationType';

export function getLocationTypeText(
  i18n: I18nFn,
  listingType: string,
  locationType: 'REMOTE' | 'HYBRID' | 'ONSITE',
) {
  if (listingType === 'EVENT') {
    return EVENT_LOCATION_TYPE(i18n)[locationType];
  }
  return LOCATION_TYPE(i18n)[locationType];
}
